import React from 'react';
import { motion } from 'framer-motion';

const SectionHeading = ({
    title,
    subtitle,
    description,
    centered = true,
    light = false,
}) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.5 }}
            className={`mb-12 ${centered ? 'text-center' : 'text-start'}`}
        >
            {/* Subtitle Badge */}
            {subtitle && (
                <span className={`inline-block px-4 py-1.5 rounded-full text-sm font-semibold mb-4 ${light
                        ? 'bg-white/20 text-white'
                        : 'bg-primary-100 text-primary-600'
                    }`}>
                    {subtitle}
                </span>
            )}

            {/* Main Title */}
            <h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${light ? 'text-white' : 'text-gray-800'
                }`}>
                {title}
            </h2>

            {/* Decorative Line */}
            <div className={`flex items-center gap-2 ${centered ? 'justify-center' : 'justify-start'} mb-4`}>
                <span className="w-12 h-1 bg-accent-500 rounded-full"></span>
                <span className="w-3 h-3 bg-primary-500 rounded-full"></span>
                <span className="w-12 h-1 bg-accent-500 rounded-full"></span>
            </div>

            {/* Description */}
            {description && (
                <p className={`max-w-2xl ${centered ? 'mx-auto' : ''} text-lg ${light ? 'text-white/80' : 'text-gray-600'
                    }`}>
                    {description}
                </p>
            )}
        </motion.div>
    );
};

export default SectionHeading;
